'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _themeManager2 = require('../../../../utilities/themeManager');

var _themeManager3 = _interopRequireDefault(_themeManager2);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

var _button = require('../../../atoms/button');

var _button2 = _interopRequireDefault(_button);

var _default = require('../props/default');

var _default2 = _interopRequireDefault(_default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();
var ORGANISM_NAME = 'bifurcated-hero';

var renderHeadline = function renderHeadline(headline) {
  if (headline) {
    return _react2.default.createElement(
      _heading2.default,
      {
        level: '2',
        className: ORGANISM_NAME + '__heading'
      },
      htmlToReactParser.parse(headline.text)
    );
  }
  return null;
};

var renderParagraph = function renderParagraph(paragraph) {
  if (paragraph) {
    return _react2.default.createElement(
      'p',
      { className: ORGANISM_NAME + '__paragraph' },
      htmlToReactParser.parse(paragraph.text)
    );
  }
  return null;
};

var renderCTA = function renderCTA(cta, panelID) {
  if (cta) {
    return _react2.default.createElement(
      _button2.default,
      {
        id: cta.id,
        href: cta.href,
        color: cta.color || null,
        className: ORGANISM_NAME + '__cta',
        fpti: cta.fpti || ORGANISM_NAME + '_' + panelID + '_' + cta.text,
        target: cta.target || '_self'
      },
      cta.text
    );
  }
  return null;
};

var renderHatchText = function renderHatchText(hatchText) {
  if (hatchText && hatchText.text) {
    return _react2.default.createElement(
      'p',
      { className: ORGANISM_NAME + '__hatch-text' },
      htmlToReactParser.parse(hatchText.text)
    );
  }
  return null;
};

var BifurcatedHero = function (_Component) {
  _inherits(BifurcatedHero, _Component);

  function BifurcatedHero(props) {
    _classCallCheck(this, BifurcatedHero);

    var _this = _possibleConstructorReturn(this, (BifurcatedHero.__proto__ || Object.getPrototypeOf(BifurcatedHero)).call(this, props));

    _this.renderHeadline = renderHeadline;
    _this.renderParagraph = renderParagraph;
    _this.renderHatchText = renderHatchText;
    _this.renderCTA = renderCTA;
    return _this;
  }

  _createClass(BifurcatedHero, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          config = _props.config,
          className = _props.className;
      var id = config.id,
          theme = config.theme,
          backgroundUrl = config.backgroundUrl;

      var _themeManager = (0, _themeManager3.default)({ content: this.props.content }, theme),
          content = _themeManager.content;

      var panelOne = content.panelOne,
          panelTwo = content.panelTwo;

      var sectionClasses = (0, _classnames2.default)(ORGANISM_NAME + '-organism', theme, className);

      return _react2.default.createElement(
        'section',
        {
          id: id,
          ref: function ref(c) {
            _this2.organismRef = c;
          },
          className: sectionClasses,
          'data-building-block': 'organism',
          style: backgroundUrl ? { backgroundImage: 'url(' + backgroundUrl + ')' } : {}
        },
        _react2.default.createElement(
          'div',
          { className: 'container ' + ORGANISM_NAME + '-content' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-lg-6 col-md-6 col-sm-12 col-xs-12 ' + ORGANISM_NAME + '-content__left-panel' },
              this.renderHeadline(panelOne.headline),
              this.renderParagraph(panelOne.paragraph),
              this.renderCTA(panelOne.primaryCta, 'panelOne'),
              this.renderHatchText(panelOne.hatchText)
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-lg-6 col-md-6 col-sm-12 col-xs-12 ' + ORGANISM_NAME + '-content__right-panel' },
              this.renderHeadline(panelTwo.headline),
              this.renderParagraph(panelTwo.paragraph),
              this.renderCTA(panelTwo.primaryCta, 'panelTwo'),
              this.renderHatchText(panelTwo.hatchText)
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: ORGANISM_NAME + '-background' },
          _react2.default.createElement(
            'div',
            { className: ORGANISM_NAME + '-background__left-panel' },
            _react2.default.createElement('div', { className: ORGANISM_NAME + '-background__left-panel__inner', style: { backgroundImage: 'url(' + panelOne.backgroundUrl + ')' } })
          ),
          _react2.default.createElement(
            'div',
            { className: ORGANISM_NAME + '-background__right-panel' },
            _react2.default.createElement('div', { className: ORGANISM_NAME + '-background__right-panel__inner', style: { backgroundImage: 'url(' + panelTwo.backgroundUrl + ')' } })
          )
        )
      );
    }
  }]);

  return BifurcatedHero;
}(_react.Component);

exports.default = BifurcatedHero;


BifurcatedHero.propTypes = {
  className: _propTypes2.default.string,
  content: _propTypes2.default.shape({
    panelOne: _propTypes2.default.shape({
      backgroundUrl: _propTypes2.default.string,
      headline: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }).isRequired,
      paragraph: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }).isRequired,
      primaryCta: _propTypes2.default.shape({
        id: _propTypes2.default.string,
        href: _propTypes2.default.string.isRequired,
        text: _propTypes2.default.string.isRequired,
        fpti: _propTypes2.default.string,
        target: _propTypes2.default.oneOf(['_self', '_blank'])
      }).isRequired,
      hatchText: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      })
    }).isRequired,
    panelTwo: _propTypes2.default.shape({
      backgroundUrl: _propTypes2.default.string,
      headline: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }).isRequired,
      paragraph: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }).isRequired,
      primaryCta: _propTypes2.default.shape({
        id: _propTypes2.default.string,
        href: _propTypes2.default.string.isRequired,
        text: _propTypes2.default.string.isRequired,
        fpti: _propTypes2.default.string,
        target: _propTypes2.default.oneOf(['_self', '_blank'])
      }).isRequired,
      hatchText: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      })
    }).isRequired
  }),
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    theme: _propTypes2.default.oneOf(['theme-background-color-white', 'theme-background-color-dark', 'theme-background-image-dark', 'theme-background-image-light']),
    backgroundUrl: _propTypes2.default.string
  })
};

BifurcatedHero.defaultProps = _default2.default;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/bifurcated-hero/jsx/BifurcatedHero.js
// module id = 1070
// module chunks = 4